import { Button, Icon, Table } from "app/components";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Radio, Switch, TableRow } from "@mui/material";
import { ChangeEvent } from "react";
import { twMerge } from "tailwind-merge";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface Props {
  data: any[];
  headers: {
    value: string;
    class: string;
    column: string;
    className: string;
    type: string;
    span?:number;
  }[];
  handleRadioChange: ChangeEvent<HTMLInputElement>;
  selectedUser: string | null;
  editUser: (key: number) => void;
  className?: string;
}

export function TableUseMais({
  data,
  headers,
  handleRadioChange,
  selectedUser,
  editUser,
  className,
}: Props) {
  // const t = useTranslations('')

  const getTableCell = (header: any, item: any, itemKey: any) => {
    if (header.type == "actions") {
      return <Button.Root  className="tw-flex tw-flex-row tw-justify-start tw-items-center tw-w-full">
        {header.actions.map((action, key) => {
          return action.action !== 'switch' ? <Button.Element key={key}
              className={twMerge(
                "tw-w-[25px] tw-h-[25px] tw-mx-1 tw-bg-transparent hover:tw-bg-transparent"
              )}
              variant="onlyicon"
              onClick={() => {
                  action.handle(item, itemKey);
              }}
              type="button"
              title={action.action}
            >
              <Icon.Root className="">
                {
                  action.action == 'editar' &&
                    <Icon.Element
                      icon={EditOutlinedIcon}
                      className={twMerge("tw-text-[#565656]")}
                    />
                }
                {
                  action.action == 'visualizar' &&
                    <Icon.Element
                      icon={VisibilityOutlinedIcon}
                      className={twMerge("tw-text-[#565656]")}
                    />
                }
                {
                  action.action == 'bloquear' &&
                    <Icon.Element
                      icon={BlockOutlinedIcon}
                      className={twMerge("tw-text-[#565656]", item.bloqueio ? 'tw-text-[#ED636E]': '')}
                    />
                }
              </Icon.Root>
            </Button.Element> :
              <Switch onChange={() => {
                action.handle(item, itemKey);
                }} sx={{
                '& .Mui-checked': {
                  color: '#48C579 !important',
                  borderColor: '#000',
                  borderWidth: 1
                },
                '.MuiSwitch-thumb': {
                  borderColor: '#000',
                  borderWidth: 1
                },
                '.Mui-checked+.MuiSwitch-track': {
                  backgroundColor: '#48C579  !important',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#48C579',
                  borderColor: '#000',
                  borderWidth: 1
                }
            }} className="tw-mt-1.5" checked={item[action.field]} defaultChecked={item[action.field]} />
        })
        }
  </Button.Root>;
    } else if (header.type == "array" && item[header.column]) {
      return item[header.column].map((i, k) => {
        return header.format(i, k);
      })
    } else if (item[header.column] !== undefined && item[header.column] !== null) {
      if (header.format) {
        return header.format(item[header.column])
      } else {
        return item[header.column];
      }
    } else return null
  };

  return (
    <Table.Root className={twMerge("mt-10 w-full", className)}>
      <Table.Element>
        <Table.Header
          header={headers}
          className="tw-justify-center tw-items-center"
        />
        <Table.Body className="">
          {data.length > 0 ? (
            data.map((row, key) => (
              <TableRow key={key}>
                {headers.map((header, index) => {
                  return (
                    <Table.Cell key={index} colSpan={header.span || 1} className={twMerge("tw-text-azulescuro", header.className)}>
                      {getTableCell(header, row, key)}
                    </Table.Cell>
                  );
                })}
           
              </TableRow>
            ))
          ) : (
            <TableRow>
              <Table.Cell colSpan={15} className={""} align="center">
                {'Sem registros para exibir'}
                {/* hahaha */}
                {/* {t('messages.nullResponsibleUser')} */}
              </Table.Cell>
            </TableRow>
          )}
        </Table.Body>
      </Table.Element>
    </Table.Root>
  );
}
